module.exports = __webpack_public_path__ + "static/media/14.9e608a8e.jpg";